export default "__VITE_ASSET__a3f25030__$_?nuxt_component=async__"